import { TUTORIAL_ORGANISING } from 'constants/tutorials';
import getTutorialCovers from './getTutorialCovers';

export default getTutorialCovers(TUTORIAL_ORGANISING);
